'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames7 = require('classnames');

var _classnames8 = _interopRequireDefault(_classnames7);

var _arrowDown = require('dibs-vg/dist/react/arrow-down');

var _arrowDown2 = _interopRequireDefault(_arrowDown);

var _ErrorMessage = require('../Common/ErrorMessage');

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ANIMATION_DELAY = 10;
var ANIMATION_DURATION = 100;

var BasicSelect = function (_Component) {
    (0, _inherits3.default)(BasicSelect, _Component);

    function BasicSelect(props) {
        (0, _classCallCheck3.default)(this, BasicSelect);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BasicSelect.__proto__ || (0, _getPrototypeOf2.default)(BasicSelect)).call(this, props));

        _initialiseProps.call(_this);

        _this.onSelect = _this.onSelect.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);
        _this.selectElement = null;

        var placeholder = props.placeholder,
            hasAnimatedPlaceholder = props.hasAnimatedPlaceholder,
            autoFocus = props.autoFocus,
            isFocused = props.isFocused,
            value = props.value;

        var isPlaceholderUp = !!placeholder && !!hasAnimatedPlaceholder && !!value;

        _this.state = {
            isAnimatedPlaceholderUp: isPlaceholderUp,
            isFocused: autoFocus || !!isFocused,
            showAnimatedPlaceholder: isPlaceholderUp,
            value: props.value || ''
        };
        return _this;
    }

    (0, _createClass3.default)(BasicSelect, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            var willUpdate = false;
            var value = this.state.value;
            var isFocused = this.state.isFocused;

            /* istanbul ignore else */
            if (typeof nextProps.value !== 'undefined' && !(this.state.value === nextProps.value === this.props.value)) {
                willUpdate = true;
                value = nextProps.value;
            }

            /* istanbul ignore else */
            if (typeof nextProps.isFocused !== 'undefined') {
                willUpdate = true;

                isFocused = nextProps.isFocused;
            }

            /* istanbul ignore else */
            if (willUpdate) {
                var _props = this.props,
                    _hasAnimatedPlaceholder = _props.hasAnimatedPlaceholder,
                    _placeholder = _props.placeholder;
                var _isAnimatedPlaceholderUp = this.state.isAnimatedPlaceholderUp;


                if (_hasAnimatedPlaceholder && _placeholder) {
                    if (_isAnimatedPlaceholderUp && !value) {
                        this.setState({
                            isAnimatedPlaceholderUp: false,
                            value: value,
                            isFocused: isFocused
                        }, function () {
                            setTimeout(function () {
                                _this2.setState({ showAnimatedPlaceholder: false });
                            }, ANIMATION_DURATION);
                        });
                    } else if (!_isAnimatedPlaceholderUp && !!value) {
                        this.setState({ value: value, isFocused: isFocused, showAnimatedPlaceholder: true }, function () {
                            setTimeout(function () {
                                _this2.setState({ isAnimatedPlaceholderUp: true });
                            }, ANIMATION_DELAY);
                        });
                    } else {
                        this.setState({ value: value, isFocused: isFocused });
                    }
                } else {
                    this.setState({ value: value, isFocused: isFocused });
                }
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (!prevState.isFocused && this.state.isFocused) {
                this.focusInput();
            } else if (prevState.isFocused && !this.state.isFocused) {
                this.blurInput();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _this3 = this;

            var _props2 = this.props,
                autoComplete = _props2.autoComplete,
                autoFocus = _props2.autoFocus,
                dataTn = _props2.dataTn,
                disabled = _props2.disabled,
                errorDataTn = _props2.errorDataTn,
                errorMessage = _props2.errorMessage,
                errorMessageAlignment = _props2.errorMessageAlignment,
                hasAnimatedPlaceholder = _props2.hasAnimatedPlaceholder,
                hasError = _props2.hasError,
                horizontalSpacing = _props2.horizontalSpacing,
                label = _props2.label,
                name = _props2.name,
                options = _props2.options,
                placeholder = _props2.placeholder,
                size = _props2.size,
                theme = _props2.theme;
            var _state = this.state,
                isFocused = _state.isFocused,
                showAnimatedPlaceholder = _state.showAnimatedPlaceholder,
                value = _state.value;


            if (!theme) {
                return null;
            }

            var showError = hasError || !!errorMessage;
            var fakeNativePlaceholder = showAnimatedPlaceholder ? "" : !value && placeholder;
            var errorDataTnString = errorDataTn ? errorDataTn : dataTn + '-error';
            var inputContainerClasses = (0, _classnames8.default)(theme.inputContainer, (_classnames = {}, (0, _defineProperty3.default)(_classnames, theme.heightDefault, !size), (0, _defineProperty3.default)(_classnames, theme.heightSmall, size === 'small'), (0, _defineProperty3.default)(_classnames, theme.heightMedium, size === 'medium'), (0, _defineProperty3.default)(_classnames, theme.heightLarge, size === 'large'), (0, _defineProperty3.default)(_classnames, theme.error, showError), (0, _defineProperty3.default)(_classnames, theme.inputFocus, !showError && isFocused), (0, _defineProperty3.default)(_classnames, theme.disabled, disabled), (0, _defineProperty3.default)(_classnames, theme.withAnimatedPlaceholder, hasAnimatedPlaceholder && !!placeholder && !!value), (0, _defineProperty3.default)(_classnames, theme.withFakeNativePlaceholder, fakeNativePlaceholder), _classnames));

            var inputClasses = (0, _classnames8.default)((0, _defineProperty3.default)({}, theme.disabled, disabled));
            var arrowClasses = (0, _classnames8.default)(theme.icon, theme.arrowDown);

            var placeholderContainerClasses = (0, _classnames8.default)(theme.inputPlaceholderContainer, (0, _defineProperty3.default)({}, theme.horizontalSpacingSmall, horizontalSpacing === 'small'));

            return _react2.default.createElement(
                'div',
                { className: theme.fieldContainer },
                label ? _react2.default.createElement(
                    'div',
                    { className: theme.label },
                    label
                ) : null,
                _react2.default.createElement(
                    'div',
                    { className: inputContainerClasses },
                    _react2.default.createElement(
                        'div',
                        { className: placeholderContainerClasses },
                        _react2.default.createElement(
                            'select',
                            {
                                autoComplete: autoComplete,
                                autoFocus: autoFocus,
                                className: inputClasses,
                                'data-tn': dataTn,
                                disabled: disabled,
                                name: name,
                                onBlur: this.onBlur,
                                onChange: this.onSelect,
                                onFocus: this.onFocus,
                                ref: function ref(select) {
                                    _this3.selectElement = select;
                                },
                                value: value
                            },
                            fakeNativePlaceholder && _react2.default.createElement(
                                'option',
                                { value: '', disabled: true },
                                fakeNativePlaceholder
                            ),
                            options.map(function (option, index) {
                                return _react2.default.createElement(
                                    'option',
                                    { key: index, value: option.value },
                                    option.label
                                );
                            })
                        ),
                        this.renderPlaceholder()
                    ),
                    _react2.default.createElement(
                        'div',
                        {
                            onClick: this.onIconClick,
                            className: (0, _classnames8.default)(theme.iconContainer, (0, _defineProperty3.default)({}, theme.iconSpacingSmall, horizontalSpacing === 'small'))
                        },
                        _react2.default.createElement(_arrowDown2.default, { className: arrowClasses })
                    )
                ),
                _react2.default.createElement(_ErrorMessage2.default, {
                    message: errorMessage,
                    dataTn: errorDataTnString,
                    className: (0, _classnames8.default)(theme.errorMessage, (0, _defineProperty3.default)({}, theme.errorMessageRight, errorMessageAlignment === 'right'))
                })
            );
        }
    }]);
    return BasicSelect;
}(_react.Component);

BasicSelect.defaultProps = {
    autoComplete: "",
    autoFocus: false,
    disabled: false,
    errorMessageAlignment: 'right',
    hasAnimatedPlaceholder: false,
    hasError: false,
    horizontalSpacing: 'default',
    options: []
};

var _initialiseProps = function _initialiseProps() {
    var _this4 = this;

    this.blurInput = function () {
        var selectElement = _this4.selectElement;
        /* istanbul ignore else */
        if (selectElement) {
            selectElement.blur();
        }
    };

    this.focusInput = function () {
        var selectElement = _this4.selectElement;
        /* istanbul ignore else */
        if (selectElement) {
            selectElement.focus();
        }
    };

    this.onBlur = function () {
        _this4.setState({
            isFocused: false
        });
    };

    this.onIconClick = function () {
        var disabled = _this4.props.disabled;
        var isFocused = _this4.state.isFocused;

        /* istanbul ignore else */

        if (!disabled && !isFocused) {
            _this4.onFocus();
        }
    };

    this.onSelect = function (e) {
        var _props3 = _this4.props,
            onChange = _props3.onChange,
            hasAnimatedPlaceholder = _props3.hasAnimatedPlaceholder,
            placeholder = _props3.placeholder;

        var value = e.target.value;

        var isAnimatedPlaceholderUp = _this4.state.isAnimatedPlaceholderUp;

        if (hasAnimatedPlaceholder && placeholder) {
            if (isAnimatedPlaceholderUp && !value) {
                _this4.setState({
                    isAnimatedPlaceholderUp: false,
                    value: value
                }, function () {
                    setTimeout(function () {
                        _this4.setState({ showAnimatedPlaceholder: false });
                    }, ANIMATION_DURATION);
                });
            } else if (!isAnimatedPlaceholderUp && !!value) {
                _this4.setState({
                    value: value,
                    showAnimatedPlaceholder: true
                }, function () {
                    setTimeout(function () {
                        _this4.setState({ isAnimatedPlaceholderUp: true });
                    }, ANIMATION_DELAY);
                });
            } else {
                _this4.setState({ value: value });
            }
        } else {
            _this4.setState({ value: value });
        }

        if (onChange) {
            onChange(e);
        }
    };

    this.onFocus = function () {
        _this4.setState({
            isFocused: true
        });
    };

    this.renderPlaceholder = function () {
        var _props4 = _this4.props,
            placeholder = _props4.placeholder,
            theme = _props4.theme;
        var _state2 = _this4.state,
            isAnimatedPlaceholderUp = _state2.isAnimatedPlaceholderUp,
            showAnimatedPlaceholder = _state2.showAnimatedPlaceholder;


        if (!theme || !showAnimatedPlaceholder) {
            return null;
        }

        var placeholderClasses = (0, _classnames8.default)(theme.animatedPlaceholderStart, (0, _defineProperty3.default)({}, theme.animatedPlaceholderEnd, isAnimatedPlaceholderUp));

        return _react2.default.createElement(
            'span',
            { className: placeholderClasses },
            placeholder
        );
    };
};

exports.default = BasicSelect;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-elements/lib/BasicSelect/index.js
// module id = ./node_modules/dibs-elements/lib/BasicSelect/index.js
// module chunks = 4